import SqlSchema from './SqlSchema.js';
export default (() => {
    const EntityType = SqlSchema.EntityType;
    const keywords = SqlSchema.keywords;

    const WordType = { ESCAPED: -1, SYMBOL: 0, TEXT: 1, NUMBER: 2, INVALID: 3 };

    const getCharType = function (charcode) {
        if(charcode >= 128){
            const allowed = [ 163 /* £ */ ]
            if (allowed.indexOf(charcode) >= 0) {
                return WordType.SYMBOL;
            }
            return WordType.INVALID;
        }

        const contiguous_text_values = [
            { begin: 95, end: 95, type: WordType.TEXT },      // '_'
            { begin: 48, end: 57, type: WordType.NUMBER },    // '0-9'
            { begin: 65, end: 90, type: WordType.TEXT },      // 'A-Z'
            { begin: 97, end: 122, type: WordType.TEXT },      // 'a-z'
            { begin: 0, end: 9, type: WordType.INVALID },   // 'invalid 0-9'
            { begin: 11, end: 31, type: WordType.INVALID },   // 'invalid 11-31'
        ];
        const length = contiguous_text_values.length;
        for (let i = 0; i < length; i++) {
            const item = contiguous_text_values[i];
            if (charcode >= item.begin && charcode <= item.end) {
                return item.type;
            }
        }
        return WordType.SYMBOL;
    }

    const updateToken = function (token, char, chartype) {
        const newToken = function () { return { value: `${char}`, type: chartype }; }
        if (token == null) { return newToken(); }

        switch (chartype) {
            case WordType.SYMBOL:
                return newToken();
            case WordType.TEXT: {
                token.type = WordType.TEXT;
                token.value += char;
            }
                break;
            case WordType.NUMBER: {
                token.type = Math.min(token.type, WordType.NUMBER);
                token.value += char;
            }
                break;
        }
        return token;
    }

    //const SeparatorType = { NEWLINE:0, SPACE:1 };
    const isSeparator = function (token) {
        const separators = ['\n', ' ', '!', '"', '%', "'", '(', ')', '*', '+', ',', '-', '.', '/', ':', ';', '<', '=', '>', '?', '[', ']', '^', '`', '{', '}', '~', '\\'];
        const length = separators.length;
        const value = token.value;
        for (let i = 0; i < length; i++) {
            const separator = separators[i];
            if (value.indexOf(separator) >= 0) {
                token.separator_type = i;
                return true;
            }
        }
        return false;
    }
    const groupTokens = function (tokens) {
        const escape = '\\';
        const groups = new Array();
        const length = tokens.length;

        let last_group = null;
        for (let i = 0; i < length; i++) {
            const token = tokens[i];

            if (isSeparator(token)) {
                if (last_group != null) { groups.push(last_group); }
                groups.push(token);
                last_group = null;
            } else if (last_group != null) {
                last_group.value += token.value;
                last_group.type = Math.min(last_group.type, token.type);
            } else {
                last_group = token;
                token.type = token.value == escape ? WordType.ESCAPED : token.type;
            }
        }
        if (last_group != null) { groups.push(last_group); }
        return groups;
    }

    const getSymbol = function (token, symbols, found_symbols) {
        const length = symbols.length;
        const token_value = token.value;
        for (let i = 0; i < length; i++) {
            const symbol = symbols[i];
            if (token_value.indexOf(symbol.keyword) == 0) {
                const target_field = symbol.keyword;
                if (target_field != null) {
                    if (found_symbols[target_field] == null) { found_symbols[target_field] = new Array(); }
                    const found = found_symbols[target_field];
                    if (found.indexOf(token_value) < 0) {
                        found.push(token_value);
                    }
                }
                return `<mark style="color:${symbol.color}">${token_value}</mark>`
            }
        }
        return token_value;
    }

    const groupEntities = function (tokens, symbols) {
        let result = '';
        const length = tokens.length;
        const keywords_length = keywords.length;

        let line = 1;
        let indentation = 0;
        const scopes = new Array();
        let last_keyword = null;

        const NL = function (indentation) {
            let result = '<div></div>';
            for (let i = 0; i < indentation; i++) {
                result += '<span class="space"></span>';
            }
            line++;
            return result;
        }

        const found_symbols = new Object();

        for (let i = 0; i < length; i++) {
            const token = tokens[i];


            if (token.value == '/') {
                if (i + 1 >= length) {
                    result += token.value;
                } else if (tokens[i + 1].value == '*') {
                    result += '<mark style="color:#669900" >/';
                    for (let j = i + 1; j < length; j++) {
                        const curr_token = tokens[j];
                        result += curr_token.value;
                        if (j > i + 1) {
                            if (curr_token.value == '/' && tokens[j - 1].value == '*') {
                                i = j;
                                break;
                            }
                        }
                    }
                    result += '</mark>' + NL(indentation);
                } else if (tokens[i + 1].value == '/') {
                    result += '<mark style="color:#669900" >/';
                    for (let j = i + 1; j < length; j++) {
                        const curr_token = tokens[j];
                        result += curr_token.value;
                        if (j > i + 1) {
                            if (curr_token.value == '\n') {
                                i = j;
                                break;
                            }
                        }
                    }
                    result += '</mark>' + NL(indentation);
                } else {
                    result += token.value;
                }
            } else {
                const upper_token = token.value.toUpperCase().trim();
                let found = false;
                for (let j = 0; j < keywords_length; j++) {
                    const keyword = keywords[j];
                    if (upper_token == keyword.name) {
                        result += `${keyword.nl_before(last_keyword) ? NL(indentation) : ''}<mark class="${keyword.type == EntityType.KEYWORD ? 'keyword' : 'function'}">${upper_token}</mark>${keyword.nl_after(last_keyword) ? NL(indentation) : ''}`;
                        found = true;
                        last_keyword = keyword.name;
                        break;
                    }
                }
                if (!found) {
                    if (token.type == WordType.NUMBER) {
                        result += `<mark class="number">${token.value}</mark>`;
                    } else {
                        switch (token.value) {
                            case '(':
                                scopes.push(line);
                                indentation++;
                                break;
                            case ')': {
                                indentation--;
                                const scope_line = scopes.pop();
                                if (scope_line < line) {
                                    token.value = NL(indentation) + token.value;
                                }
                            }
                                break;
                            case '\n':
                                token.value = ' ';
                                break;
                            case ';':
                                token.value += NL(indentation);
                                break;
                            case ',': {
                                const scope_line = scopes[scopes.length - 1];
                                if (scope_line < line || scope_line == undefined) {
                                    token.value += NL(indentation);
                                }
                            }
                                break;
                            case "'":
                                result += `<mark class="text">'`;
                                for (i++; i < length; i++) {
                                    const curr_token = tokens[i];
                                    result += getSymbol(curr_token, symbols, found_symbols);
                                    if (curr_token.value == "'") {
                                        if (tokens[i - 1].value != '\\') {
                                            break;
                                        }
                                    }
                                }
                                result += '</mark>';
                                continue;
                        }
                        result += getSymbol(token, symbols, found_symbols);
                    }
                }
            }


        }

        return {
            formatted_text: result,
            found_symbols: found_symbols
        };
    }

    const sortSymbols = function (symbols) {
        const length = symbols.length;
        const source = new Array();
        const sorted = new Array();

        let max = 0;
        for (let i = 0; i < length; i++) {
            max = Math.max(symbols[i].keyword.length, max);
            source.push(Object.assign({}, symbols[i], { rank: symbols[i].keyword.length }))
        }

        for (; max > 0; max--) {
            for (let i = 0; i < length; i++) {
                const item = source[i];
                if (item.rank == max) {
                    sorted.push(item);
                }
            }
        }

        return sorted;

    }


    return {
        parse(input_text, symbols) {
            const text_length = input_text.length;
            const tokens = new Array();

            let current_token = null;
            for (let i = 0; i < text_length; i++) {
                const current_char = input_text[i];
                const current_charcode = input_text.charCodeAt(i);
                const current_chartype = getCharType(current_charcode);
                if (current_chartype == WordType.INVALID) {
                    const prima = input_text.substr(0, i);
                    const dopo = input_text.substr(i + 1, text_length - i);

                    input_text = prima + " " + dopo;
                    i--;
                    continue;
                }

                const updated_token = updateToken(current_token, current_char, current_chartype);
                if (updated_token != current_token) {
                    if (current_token != null) { tokens.push(current_token); }
                    current_token = updated_token;
                }
                if (updated_token.type == WordType.SYMBOL) {
                    tokens.push(current_token);
                    current_token = null;
                }
            }
            if (current_token != null) {
                tokens.push(current_token);
            }

            const sorted_symbols = sortSymbols(symbols);
            return Object.assign({clean_text: input_text}, groupEntities(groupTokens(tokens), sorted_symbols));
        }
    }
})();